import { EMPTY_STRING } from '../../../constants/common'
import i18n from '../../../i18n'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'
import {
  DocFlowSendingCommunicationSettingsWidget,
  DocFlowSendingEmailSettingsWidget,
  DocFlowSendingEpostSettingsWidget,
  DocFlowSendingResultWidget,
} from '../DocFlowWidgets'

import {
  DOC_FLOW_SENDING_NEXT_PHASE_SERVER_ERRORS,
  DOC_FLOW_SENDING_TABLE_CONFIG_URL,
  DOC_FLOW_SENDING_TABLE_FILTER_STATE_URL,
  DocFlowSendingWidgetPhaseStatus,
  DocFlowSendingWidgetProcessFieldName,
  DocFlowSendingWidgetStatus,
  DocFlowSendingWidgetType,
} from './DocFlowSending.constants'

export function getSendingTableApiUrls(id) {
  return {
    filterStateApi: `${DOC_FLOW_SENDING_TABLE_FILTER_STATE_URL}?object_id=${id}`,
    listApi: `${DOC_FLOW_API_URL}${id}/sending-files/filter/`,
    tableConfigApi: DOC_FLOW_SENDING_TABLE_CONFIG_URL,
  }
}

export function getDocFlowSendingWidgets() {
  return [
    {
      name: DocFlowSendingWidgetType.CommunicationSettings,
      title: i18n.t('DocumentStapling.SendingPhaseCommunicationWidgetTitleKey'),
    },
    {
      name: DocFlowSendingWidgetType.EpostSettings,
      title: i18n.t('DocumentStapling.SendingPhaseEpostWidgetTitleKey'),
    },
    {
      name: DocFlowSendingWidgetType.EmailSettings,
      title: i18n.t('DocumentStapling.SendingPhaseEmailWidgetTitleKey'),
    },
    {
      name: DocFlowSendingWidgetType.Result,
      title: i18n.t('DocumentStapling.SendingPhaseResultWidgetTitleKey'),
    },
  ]
}

export function renderWidget(props) {
  switch (props.name) {
    case DocFlowSendingWidgetType.CommunicationSettings:
      return <DocFlowSendingCommunicationSettingsWidget {...props} />

    case DocFlowSendingWidgetType.EpostSettings:
      return <DocFlowSendingEpostSettingsWidget {...props} />

    case DocFlowSendingWidgetType.EmailSettings:
      return <DocFlowSendingEmailSettingsWidget {...props} />

    case DocFlowSendingWidgetType.Result:
      return <DocFlowSendingResultWidget {...props} />

    default:
      return null
  }
}

export function isDocFlowSendingActiveWidget(value) {
  return value === DocFlowSendingWidgetStatus.Active
}

export function getDocFlowSendingActiveWidget(processData) {
  switch (true) {
    case isDocFlowSendingActiveWidget(
      processData[
        DocFlowSendingWidgetProcessFieldName.CommunicationSettingsStatus
      ]
    ):
      return DocFlowSendingWidgetType.CommunicationSettings

    case isDocFlowSendingActiveWidget(
      processData[DocFlowSendingWidgetProcessFieldName.EpostSettingsStatus]
    ):
      return DocFlowSendingWidgetType.EpostSettings

    case isDocFlowSendingActiveWidget(
      processData[DocFlowSendingWidgetProcessFieldName.EmailSettingsStatus]
    ):
      return DocFlowSendingWidgetType.EmailSettings

    case isDocFlowSendingActiveWidget(
      processData[DocFlowSendingWidgetProcessFieldName.ResultsStatus]
    ):
      return DocFlowSendingWidgetType.Result

    default:
      return DocFlowSendingWidgetType.CommunicationSettings
  }
}

export function isDocFlowSendingWidgetStatusCompleted(value) {
  return value === DocFlowSendingWidgetPhaseStatus.Completed
}

export function isDocFlowSendingWidgetStatusStarted(value) {
  return value === DocFlowSendingWidgetPhaseStatus.Started
}

export function isDocFlowSendingWidgetStatusNotStarted(value) {
  return value === DocFlowSendingWidgetPhaseStatus.NotStarted
}

export function isDocFlowSendingWidgetStatusSkipped(value) {
  return value === DocFlowSendingWidgetPhaseStatus.Skipped
}

export function isDocFlowSendingWidgetStatusStartedWithError(value) {
  return value === DocFlowSendingWidgetPhaseStatus.StartedWidthError
}

export function isDocFlowSendingWidgetTypeResult(widget) {
  return widget === DocFlowSendingWidgetType.Result
}

export function isDocFlowSendingWidgetTypeCommunicationSettings(widget) {
  return widget === DocFlowSendingWidgetType.CommunicationSettings
}

export function isDocFlowSendingWidgetTypeEmailSettings(widget) {
  return widget === DocFlowSendingWidgetType.EmailSettings
}

export function isDocFlowSendingWidgetTypeEpostSettings(widget) {
  return widget === DocFlowSendingWidgetType.EpostSettings
}

export function getDocFlowSendingEpostServerErrors(error) {
  const errorText = error?.response?.data?.errors ?? EMPTY_STRING

  return DOC_FLOW_SENDING_NEXT_PHASE_SERVER_ERRORS[errorText]
    ? i18n.t(DOC_FLOW_SENDING_NEXT_PHASE_SERVER_ERRORS[errorText])
    : errorText
}
